module.exports = __webpack_public_path__ + "static/media/siddharth-guntur-trip-17.818e7384.png";